import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../../Component/Layouts/App/Candidates/StudentApp/Icon';
import { GradientMark, SectionTitle, XpBadge, MenuButton } from '../../../../Component/Layouts/App/Candidates/StudentApp/StudentUi';
import { useStudent } from '../../../../Component/Layouts/App/Candidates/StudentApp/StudentContext';
import { STUDENT_BASE } from '../../../../Component/Layouts/App/Candidates/StudentApp/studentData';

const Home = () => {
  const navigate = useNavigate();
  const { xp, challengeDone, startChallenge } = useStudent();
  const progress = xp >= 1290 ? 80 : 72;

  return (
    <>
      <div className="sa-top">
        <MenuButton />
        <div className="sa-logo">
          <Icon name="logo" />
          Focalyt
        </div>
        <div className="sa-sp" />
        <button type="button" className="sa-ib" aria-label="For you" onClick={() => navigate(`${STUDENT_BASE}/activity`)}>
          <Icon name="bell" />
          <i className="sa-dot" />
        </button>
        <div className="sa-av">AS</div>
      </div>

      <div className="sa-row">
        <div className="sa-sp">
          <h1>Hi, Aditi!</h1>
          <div className="sa-mut">Keep going! Your journey builds a brighter future.</div>
        </div>
        <div className="sa-streak">
          <Icon name="flame" filled />
          7 days
        </div>
      </div>

      <div className="sa-lvl">
        <div className="sa-row">
          <div className="sa-av" style={{ width: 56, height: 56, fontSize: 18 }}>AS</div>
          <div className="sa-sp">
            <div className="sa-b" style={{ fontSize: 17 }}>Level 7</div>
            <div className="sa-mut">Explorer</div>
            <span className="sa-xp lg">
              <Icon name="star" filled /> {xp.toLocaleString()} XP
            </span>
          </div>
          <Icon name="next" />
        </div>
        <div className="sa-bar"><i style={{ width: `${progress}%` }} /></div>
        <div className="sa-mut" style={{ marginTop: 6 }}>{progress}% to Level 8</div>
      </div>

      <div className="sa-tiles">
        <button type="button" className="sa-tile" style={{ background: 'linear-gradient(135deg,#2563eb,#4f46e5)' }} onClick={() => navigate(`${STUDENT_BASE}/course`)}>
          <Icon name="learn" />Learn<small>Courses & certs</small>
        </button>
        <button type="button" className="sa-tile" style={{ background: 'linear-gradient(135deg,#8b5cf6,#6d28d9)' }} onClick={() => navigate(`${STUDENT_BASE}/job`)}>
          <Icon name="job" />Career<small>Jobs & internships</small>
        </button>
        <button type="button" className="sa-tile" style={{ background: 'linear-gradient(135deg,#10b981,#059669)' }} onClick={() => navigate(`${STUDENT_BASE}/club`)}>
          <Icon name="users" />Campus Life<small>Clubs & events</small>
        </button>
      </div>

      <SectionTitle title="Today's challenge" />
      <div className="sa-card sa-row">
        <GradientMark name="zap" from="#f59e0b" to="#f97316" />
        <div className="sa-sp">
          <div className="sa-b">Finish a 10-minute lesson</div>
          <XpBadge amount={50} />
        </div>
        {challengeDone ? (
          <span className="sa-b" style={{ color: '#10a56b' }}>Done</span>
        ) : (
          <button type="button" className="sa-btn" onClick={startChallenge}>Start</button>
        )}
      </div>

      <SectionTitle title="Your goals" />
      <div className="sa-card sa-row">
        <GradientMark name="target" from="#8b5cf6" to="#ec4899" />
        <div className="sa-sp">
          <div className="sa-b">Complete 2 courses this month</div>
          <div className="sa-bar"><i style={{ width: '50%' }} /></div>
        </div>
        <span className="sa-mut">1/2</span>
      </div>

      <SectionTitle title="Continue learning" />
      <div className="sa-card sa-row">
        <GradientMark name="mega" from="#8b5cf6" to="#ec4899" />
        <div className="sa-sp">
          <div className="sa-b" style={{ fontSize: 14 }}>Digital Marketing</div>
          <div className="sa-mut">Module 4: Social Media Strategy</div>
          <div className="sa-bar"><i style={{ width: '70%' }} /></div>
        </div>
        <button type="button" className="sa-btn" onClick={() => navigate(`${STUDENT_BASE}/course`)}>Continue</button>
      </div>

      <SectionTitle title="Latest achievement" action="See all" onAction={() => navigate(`${STUDENT_BASE}/achievements`)} />
      <button type="button" className="sa-card sa-row sa-click" onClick={() => navigate(`${STUDENT_BASE}/achievement`)}>
        <GradientMark name="trophy" from="#fbbf24" to="#f97316" />
        <div className="sa-sp">
          <div className="sa-b" style={{ fontSize: 14 }}>Won 2nd Prize – Inter-College Hackathon</div>
          <XpBadge amount={150} />
        </div>
        <Icon name="next" />
      </button>
    </>
  );
};

export default Home;
